import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiBaseResponse } from '../models';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  constructor(private http: HttpClient) {}

  getTimezone(): Observable<{ value: number; text: string }[]> {
    return this.http
      .get<ApiBaseResponse<{ value: number; text: string }[]>>(
        `${environment.apiUrl}/timezone`
      )
      .pipe(map((it) => it.data));
  }
}
